import { collection, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from './config';
import { createExperience } from './experienceService';

/**
 * Seed experiences if the collection is empty
 */
export const seedExperiences = async () => {
    try {
        // Check if experiences already exist
        const experiencesCollection = collection(db, 'experiences');
        const snapshot = await getDocs(experiencesCollection);

        if (snapshot.empty) {
            console.log('Seeding experiences collection...');

            // Define initial experiences
            const initialExperiences = [
                {
                    company: '10xScale.ai',
                    position: 'Software Engineer (Part-time)',
                    location: 'Remote',
                    startDate: '2025-01',
                    endDate: '',
                    descriptions: [
                        'Joined as a founding team member in developing a SaaS product, contributing to product strategy while leading the technical implementation across mobile and web platforms.',
                        'Spearheaded the development of cross-platform applications using Flutter, while supporting web frontend with ReactJS, establishing core infrastructure for product scalability.',
                        'Led technical architecture decisions aligning product development with business objectives'
                    ],
                    website: 'https://10xscale.ai',
                    companyLogo: '',
                },
                {
                    company: 'Padma Smart Technology',
                    position: 'Software Engineer (Flutter)',
                    location: 'Dhaka, Bangladesh',
                    startDate: '2022-01',
                    endDate: '2024-12',
                    descriptions: [
                        'Developed mobile applications for IoT-based smart meter solutions, enabling real-time monitoring and control.',
                        'Created technician field apps for IoT device setup & gateway integration',
                        'Collaborated cross-functionally on scalable system development',
                        'Optimized system performance through iterative improvements'
                    ],
                    website: 'https://padma.tech',
                    companyLogo: '',
                },
                {
                    company: 'Kinetik Dynamics',
                    position: 'Software Engineer (Flutter) - Part-time',
                    location: 'Dhaka, Bangladesh',
                    startDate: '2023-01',
                    endDate: '2023-12',
                    descriptions: [
                        'Spearheaded development of Glanzon, Go Doctor, and Treak&Tread mobile applications',
                        'Crafted intuitive interfaces with seamless booking and secure payment systems',
                        'Partnered with stakeholders to identify priorities and deliver high-performance solutions'
                    ],
                    website: 'https://kinetik.co',
                    companyLogo: '',
                },
                {
                    company: 'Freelancer',
                    position: 'Flutter Developer',
                    location: 'Remote',
                    startDate: '2018-11',
                    endDate: '2021-02',
                    descriptions: [
                        'Led multidisciplinary teams in mobile app development, utilizing Flutter SDK to deliver high-quality native interfaces.',
                        'Contributed to the success of Yebook app with 500k+ installations, enhancing functionality and accessibility.'
                    ],
                    website: '',
                    companyLogo: '',
                }
            ];

            // Create each experience in reverse order to maintain chronological display
            for (let i = initialExperiences.length - 1; i >= 0; i--) {
                await createExperience(initialExperiences[i]);
            }

            console.log('Successfully seeded experiences collection!');
        } else {
            console.log('Experiences collection already has data, skipping seed operation.');
        }
    } catch (error) {
        console.error('Error seeding experiences:', error);
    }
}; 